// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19ued","requiredAsterisk":"Info_requiredAsterisk__1UbWV"};